import { render, staticRenderFns } from "./PopupMedicalMenuDetail.vue?vue&type=template&id=6b9417ac&scoped=true&"
import script from "./PopupMedicalMenuDetail.vue?vue&type=script&lang=ts&"
export * from "./PopupMedicalMenuDetail.vue?vue&type=script&lang=ts&"
import style0 from "./PopupMedicalMenuDetail.vue?vue&type=style&index=0&id=6b9417ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9417ac",
  null
  
)

export default component.exports